import React, { PureComponent, Fragment } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Button, Checkbox, Row, Col, message, Modal, Tooltip } from 'antd';
import { connect } from 'dva';

import EditRegionSelector from './EditRegionSelector';
import PolicySelector from './PolicySelector';

@connect(({ cloudAccount, loading }) => ({
  updating: cloudAccount.updating,
}))
class IAMRole extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      checkNick: false,
      regions: [],
      policy: this.props.customerData[0].policy,
    };
  }

  state = { visible: false, visibleAccId: false, visibleExtId: false };
  showModal = () => {
    this.setState({
      visible: true,
      visibleAccId: false,
      visibleExtId: false,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
      visibleAccId: false,
      visibleExtId: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      visibleAccId: false,
      visibleExtId: false,
    });
  };
  check = () => {
    this.props.form.validateFields(err => {
      if (!err) {
      }
    });
  };
  selectedpolicy(policy) {
    this.setState({
      policy,
    });
  }
  handleChange = e => {
    this.setState(
      {
        checkNick: e.target.checked,
      },
      () => {
        this.props.form.validateFields(['nickname'], { force: true });
      }
    );
  };
  selectedregion(regions) {
    this.setState({
      regions,
    });
  }
  selectedpolicy(policy) {
    this.setState({
      policy,
    });
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      values.regions = this.state.regions;
      values.policy = this.state.policy;
      values.provider = this.props.customerData[0].provider;
      values.cloudAccount = this.props.customerData[0].id;
      if (!err) {
        this.props.updateData(values);

        // message.success('CloudAccount updated successfully');
      } else {
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { customerData } = this.props;

    return (
      <div>
        <div style={{ marginTop: 13 }}>
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Col span={10}>
                <Form.Item label="AWS Account Name">
                  {getFieldDecorator('AWSAccountName', {
                    initialValue:
                      customerData && customerData[0].accountName
                        ? customerData[0].accountName
                        : '',

                    rules: [
                      {
                        //   required: true,
                        message: 'Please enter your AWS Account Name',
                      },
                    ],
                  })(<Input placeholder="AWS Account Name" />)}
                </Form.Item>
              </Col>
              <Col span={10} offset={2}>
                <Form.Item label="Select Regions">
                  {getFieldDecorator('SelectRegions', {
                    rules: [
                      {
                        required: this.state.checkNick,
                        message: 'Please Select your Regions',
                      },
                    ],
                  })(
                    <EditRegionSelector
                      provider={customerData && customerData[0].provider}
                      region={customerData && customerData[0].regions}
                      selectregion={this.selectedregion.bind(this)}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <Form.Item
                  label={
                    <span>
                      AWS Account ID&nbsp;{' '}
                      <Tooltip title="Please note the Account Id is required for IAM Role.">
                        <QuestionCircleOutlined style={{ verticalAlign: 0 }} />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('AWSAccountId', {
                    initialValue:
                      customerData && customerData[0].accountId ? customerData[0].accountId : '',

                    rules: [
                      {
                        //   required: true,
                        message: 'Please enter your AWS Account Id',
                      },
                    ],
                  })(<Input placeholder="AWS Account Id" disabled />)}
                </Form.Item>
              </Col>
              <Col span={10} offset={2}>
                <Form.Item
                  label={
                    <span>
                      External ID&nbsp;
                      <Tooltip title="External ID is the Cloudnosys generated ID you need to enter in your Amazon Web Services Portal in IAM Role.">
                        <QuestionCircleOutlined style={{ verticalAlign: 0 }} />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('AWSExternalID', {
                    initialValue:
                      customerData && customerData[0].externalId ? customerData[0].externalId : '',

                    rules: [
                      {
                        required: this.state.checkNick,
                        message: 'Please enter your AWS External ID ',
                      },
                    ],
                  })(<Input placeholder="AWS External ID" disabled />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <PolicySelector
                  selectedpolicy={this.selectedpolicy.bind(this)}
                  policy={customerData[0].policy && customerData[0].policy}
                />
              </Col>
              <Col span={10} offset={2}>
                <Form.Item
                  label={
                    <span>
                      Role ARN&nbsp;
                      <Tooltip title="Help">
                        <QuestionCircleOutlined
                          style={{ verticalAlign: 0 }}
                          onClick={this.showModal}
                        />
                      </Tooltip>
                      <Modal
                        title="Amazon Resource Number (ARN)"
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                      >
                        <p>
                          <b>Step 1: </b>
                          To create IAM Role, log in to your AWS IAM console{' '}
                          <a target="blank" href="https://signin.aws.amazon.com/">
                            {' '}
                            <b>https://signin.aws.amazon.com/</b>{' '}
                          </a>
                          .
                        </p>
                        <p>
                          <b>Step 2: </b>
                          Click 'Roles' in side menu, click on "Create Role" button.
                        </p>
                        <p>
                          <b>Step 3: </b>
                          Click on 'Another AWS Account' box, copy your Account ID from cloudnosys
                          dashboard and paste it in the Account field of aws console.
                        </p>
                        <p>
                          <b>Step 4: </b>
                          Click on the "Require external ID" checkbox, copy the external Id from
                          your cloudnosys dashboard and paste it the External Id field of aws
                          console, then click next.
                        </p>
                        <p>
                          <b>Step 5: </b>
                          In the next screen that appears, search for your desired policy and add
                          it, click next.
                        </p>
                        <p>
                          <b>Step 6: </b>
                          Enter valid name and description in next Review Policy screen, then click
                          Create Policy.
                        </p>
                        <p>
                          <b>Step 7: </b>
                          This would successfully create your IAM Role and generate a{' '}
                          <b>Role ARN</b>.
                        </p>
                        <p>
                          <b>Step 8: </b>
                          To get your Role ARN, navigate back to <b>Roles</b> in AWS console, locate
                          your Role name, click on that and it would open up your role summary,
                          displaying your <b>Role ARN</b> on the top.
                        </p>
                        <p>
                          <b>Step 9: </b>
                          Copy <b>Role ARN</b> from AWS console and paste it in the Role ARN field
                          in Cloudnosys Dashboard.
                        </p>
                      </Modal>
                    </span>
                  }
                >
                  {getFieldDecorator('RoleARN', {
                    initialValue:
                      customerData && customerData[0].roleArn ? customerData[0].roleArn : '',

                    rules: [
                      {
                        required: this.state.checkNick,
                        message: 'Please enter your Role ARN',
                      },
                    ],
                  })(<Input placeholder="Role ARN" disabled />)}
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button
                loading={this.props.updating}
                type="primary"
                htmlType="submit"
                style={{ float: 'right' }}
              >
                Update
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedApp = Form.create()(IAMRole);

export default WrappedApp;
